type Props = { size?: number; color?: string };

export function IconInfo({ size = 15, color = "currentColor" }: Props) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke={color}
			strokeWidth="1.9"
			strokeLinecap="round"
			aria-hidden="true"
		>
			<circle cx="12" cy="12" r="9" />
			<path d="M12 8.5v.4M12 11.5v4" />
		</svg>
	);
}
